import { buttonsRegex, inputHiddenRegex, queueMessageRegex, sellerMessageRegex } from "../utils/messageRegex"

let lastMessagensCount = 0

const updateInputVisibility = (body) => {    
    const inputContainerElement = document && document.querySelector(".Twilio-MessageInput-default")
    const textAreaElement = inputContainerElement && inputContainerElement.querySelector('textarea')
    const fileInputButtonElement = inputContainerElement && inputContainerElement.querySelector('button')
    const fileInputElement = inputContainerElement && inputContainerElement.querySelector('input[type=file]')
    
    if(textAreaElement) {
        const shouldHideInput = !body || buttonsRegex.test(body) || inputHiddenRegex.test(body) || queueMessageRegex.test(body) || sellerMessageRegex.test(body)
        
        if (shouldHideInput) {
            setTimeout(() => {
                textAreaElement.style.opacity = 0
                textAreaElement.setAttribute('disabled', true)
                
                fileInputButtonElement.style.opacity = 0.5
                fileInputButtonElement.setAttribute('disabled', true)
                fileInputElement.setAttribute('disabled', true)
            }, 10)
        } else {
            setTimeout(() => {
                textAreaElement.style.opacity = 1
                textAreaElement.removeAttribute('disabled')
                
                fileInputButtonElement.style.opacity = 1
                fileInputButtonElement.removeAttribute('disabled')
                fileInputElement.removeAttribute('disabled')
            }, 10)
        }
    }
}

export const inputVisibilitySubscriber= (state) => {
    const { channelSid, isEntryPointExpanded } = state.flex.session
    if(!channelSid) {
        return
    }
    
    const channel = state.flex.chat.channels[channelSid]
    if(!channel){
        return
    }
    
    const isLoadingSomething = channel.isLoadingChannel || channel.isLoadingMembers || channel.isLoadingMessages
    if(isLoadingSomething) {
        return
    }
    
    const lastMessage = channel.messages.at(-1)
    if(!lastMessage) {
        lastMessagensCount = 1
        updateInputVisibility(null)
        return
    }
    
    const currentMessageCount = channel.messages.length
    if(lastMessagensCount !== currentMessageCount && !lastMessage.isFromMe && isEntryPointExpanded) {
        lastMessagensCount = currentMessageCount
        updateInputVisibility(lastMessage.source.state.body)
        return
    }
}